import { render, staticRenderFns } from "./WalletTransactionsTable.vue?vue&type=template&id=e055a5c8&"
import script from "./WalletTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./WalletTransactionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports